import React, { useState } from "react";
import PubNub from "pubnub";
import { PubNubProvider } from "pubnub-react";

import ChatWrapper from './Chat';

function App({ uuid, pn_keys, token: rawToken, is_supervisor }) {
  const [token, setToken] = useState(rawToken);

  const pubnub = new PubNub({
    publishKey: pn_keys.publish,
    subscribeKey: pn_keys.subscribe,
    userId: uuid,
    heartbeatInterval: 0,
    suppressLeaveEvents: true,
    autoNetworkDetection: false,
    presenceTimeout: 0
  });

  // Only set and parse token if it's not a demo token
  let parsedToken = null;
  if (token && !token.startsWith('demo-')) {
    pubnub.setToken(token);
    try {
      parsedToken = pubnub.parseToken(token);
    } catch (error) {
      console.warn('Failed to parse PubNub token:', error);
      parsedToken = null;
    }
  } else {
    console.log('Using demo mode - no token parsing');
  }

  return (
    <PubNubProvider client={pubnub}>
      <ChatWrapper {...{ setToken, parsedToken, is_supervisor }} />
    </PubNubProvider>
  );
}

export default App;